import { useState } from "react";
import { collections, collectionGroups } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function CollectionIndex() {
  const [active, setActive] = useState("全部");
  const list =
    active === "全部"
      ? collections
      : collections.filter((item) => item.group === active);

  return (
    <section id="index" className="bg-background-50 px-6 lg:px-10 py-14 md:py-20 scroll-mt-24">
      <SectionHeading
        index="01"
        label="Collection Index"
        title="专题合集索引"
        desc="按题材整理好的专题列表，每个合集都已按顺序排好，点进去就能从第一条开始连着看。"
      />

      <div className="mt-8 flex flex-wrap items-center gap-2">
        {collectionGroups.map((group) => (
          <button
            key={group}
            type="button"
            onClick={() => setActive(group)}
            className={`px-1 py-1 rounded-full transition-colors cursor-pointer whitespace-nowrap ${
              active === group
                ? "bg-primary-500"
                : "bg-background-100 hover:bg-background-200"
            }`}
          >
            <span
              className={`block px-4 py-1.5 rounded-full text-sm ${
                active === group
                  ? "text-background-50"
                  : "text-foreground-700"
              }`}
            >
              {group}
            </span>
          </button>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {list.map((item) => (
          <a
            key={item.index}
            href="#hot"
            className="group flex flex-col rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors p-5 cursor-pointer"
          >
            <div className="flex items-start justify-between">
              <span className="font-label text-4xl text-background-400 group-hover:text-primary-300 transition-colors leading-none">
                {item.index}
              </span>
              <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
                {item.group}
              </span>
            </div>
            <h5 className="mt-4 font-heading font-bold text-[17px] text-foreground-950">
              {item.name}
            </h5>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">
              {item.desc}
            </p>
            <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between">
              <span className="text-xs text-foreground-500 flex items-center gap-1.5">
                <i className="ri-stack-line"></i>
                {item.count} 条
              </span>
              <span className="text-xs text-primary-600 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                查看合集
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}